import { render, staticRenderFns } from "./editMerchantComponent.vue?vue&type=template&id=008ae5f7&"
import script from "./editMerchantComponent.vue?vue&type=script&lang=js&"
export * from "./editMerchantComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports